module.exports = __webpack_public_path__ + "static/media/dashboard.727ebe30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard.svg
// module id = 545
// module chunks = 1